import React from "react";
import { useTeamConfig } from "../hooks/useTeamConfig";
import { useAppStore } from "../store";
import { selectCartManager } from "../store/data/purchaseSeats/cartManager";
import { findLocationsHeldInCart } from "@/shared/modules/PurchaseSeats/utils.cart";
import { findAllPerksLocations } from "@/shared/modules/PurchaseSeats/utils.perks";
import { createCancelCartPayload } from "../api/api.utils";

export const AppCloseCancelCartHandler = () => {
  const teamConfig = useTeamConfig();
  const isCartCacheEnabled = teamConfig?.purchaseSeatConfigs?.isCartCacheEnabled; // prettier-ignore
  const cartState = useAppStore(selectCartManager);

  const cancelCart = async () => {
    if (isCartCacheEnabled) return;
    if (!cartState?.cartId) return;

    try {
      const seatLocations = (findLocationsHeldInCart(cartState) || []) as string[]; // prettier-ignore
      const perkLocations = findAllPerksLocations(cartState);
      const payload = createCancelCartPayload({
        seatLocations,
        perkLocations,
        teamConfig,
        cartState,
        offerId: cartState?.offerId,
      });
      const body = new URLSearchParams();
      body.append("stringPayload", JSON.stringify(payload));
      navigator.sendBeacon("/.netlify/functions/cancel-cart-beacon", body);
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.addEventListener("pagehide", cancelCart);
    return () => {
      window.removeEventListener("pagehide", cancelCart);
    };
  }, [cartState.cartId]);

  return <></>;
};
